/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetTypeSubsystemMappingResponseDto
 */
export interface AssetTypeSubsystemMappingResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetTypeSubsystemMappingResponseDto
     */
    id: string;
    /**
     * ID of the asset type
     * @type {string}
     * @memberof AssetTypeSubsystemMappingResponseDto
     */
    assetTypeId: string;
    /**
     * ID of the subsystem
     * @type {string}
     * @memberof AssetTypeSubsystemMappingResponseDto
     */
    subsystemId: string;
    /**
     * Code of the asset type
     * @type {string}
     * @memberof AssetTypeSubsystemMappingResponseDto
     */
    assetTypeCode: string;
    /**
     * Code of the subsystem
     * @type {string}
     * @memberof AssetTypeSubsystemMappingResponseDto
     */
    subsystemCode: string;
    /**
     * Component classes associated with this mapping
     * @type {Array<string>}
     * @memberof AssetTypeSubsystemMappingResponseDto
     */
    componentClassIds: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeSubsystemMappingResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeSubsystemMappingResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the AssetTypeSubsystemMappingResponseDto interface.
 */
export function instanceOfAssetTypeSubsystemMappingResponseDto(value: object): value is AssetTypeSubsystemMappingResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetTypeId' in value) || value['assetTypeId'] === undefined) return false;
    if (!('subsystemId' in value) || value['subsystemId'] === undefined) return false;
    if (!('assetTypeCode' in value) || value['assetTypeCode'] === undefined) return false;
    if (!('subsystemCode' in value) || value['subsystemCode'] === undefined) return false;
    if (!('componentClassIds' in value) || value['componentClassIds'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function AssetTypeSubsystemMappingResponseDtoFromJSON(json: any): AssetTypeSubsystemMappingResponseDto {
    return AssetTypeSubsystemMappingResponseDtoFromJSONTyped(json, false);
}

export function AssetTypeSubsystemMappingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetTypeSubsystemMappingResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetTypeId': json['assetTypeId'],
        'subsystemId': json['subsystemId'],
        'assetTypeCode': json['assetTypeCode'],
        'subsystemCode': json['subsystemCode'],
        'componentClassIds': json['componentClassIds'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function AssetTypeSubsystemMappingResponseDtoToJSON(json: any): AssetTypeSubsystemMappingResponseDto {
    return AssetTypeSubsystemMappingResponseDtoToJSONTyped(json, false);
}

export function AssetTypeSubsystemMappingResponseDtoToJSONTyped(value?: AssetTypeSubsystemMappingResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetTypeId': value['assetTypeId'],
        'subsystemId': value['subsystemId'],
        'assetTypeCode': value['assetTypeCode'],
        'subsystemCode': value['subsystemCode'],
        'componentClassIds': value['componentClassIds'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

